exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-add-new {\r\n  float: right;\r\n  display: inline-block;\r\n  height: 29px;\r\n  line-height: 9px;\r\n  margin-left: 10px;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Biziclick/bizisystem/src/app/main/pages/organization-list/organization-list.component.css
// module id = ../../../../../src/app/main/pages/organization-list/organization-list.component.css
// module chunks = main